import ActivityBonusNotification from './ActivityBonusNotification'

export default ActivityBonusNotification
